// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"16":"99274c0d","28":"9bd4d767","231":"62793d4b","726":"29a540d8","788":"d3f354f0"}[chunkId] + ".css";
};